import { Col, Form, Row, Select, Switch } from 'antd';
import classNames from 'classnames';
import { PercelenModel } from 'pages/bodem-en-gewas/percelen-old/models/percelenMock';
import { FC } from 'react';
import { roundAndDisplayWithDecimals } from '../../../../../helpers/logica/round-and-display-with-decimals';
import { grondSoort, methodes } from '../../settings';
import styles from '../../styles.module.scss';

const leftWithPadding = classNames(['text-left', styles.paddingRight]);

interface PerceelRowProps {
  perceel: PercelenModel['gekoppeldeGewaspercelen'][0];
  index: number;
  isKlwReadOnly: boolean;
  shownGroup: string;
  gebruikKoppeltoolKoolstofBodem;
  gebruikKoppeltool;
}
export const PerceelRow: FC<PerceelRowProps> = ({ perceel, index, isKlwReadOnly, shownGroup, gebruikKoppeltoolKoolstofBodem, gebruikKoppeltool }) => {
  return (
    <Row gutter={12}>
      <Col
        span={3}
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
        {perceel?.perceelNaam}
      </Col>
      <Col className={leftWithPadding} span={3}>
        {perceel.gewasCodeRvo} - {perceel.gewascodeOmschrijving}
      </Col>
      <Col className={leftWithPadding} span={2}>
        {grondSoort[perceel.grondsoortcategorieId]}
      </Col>
      <Col className={leftWithPadding} span={2}>
        {perceel.grondwatertrap}
      </Col>
      <Col className={styles.paddingRight} span={2}>
        {roundAndDisplayWithDecimals(2)(perceel.oppervlakte)}
      </Col>

      {shownGroup === 'fosfaat' && gebruikKoppeltool ? (
        <>
          <Col className={styles.paddingRight} span={2}>
            {roundAndDisplayWithDecimals(2)(perceel.pal)}
          </Col>
          <Col className={styles.paddingRight} span={2}>
            {roundAndDisplayWithDecimals(2)(perceel.pw)}
          </Col>
          <Col className={styles.paddingRight} span={2}>
            {roundAndDisplayWithDecimals(2)(perceel.ppae)}
          </Col>
          <Col className={styles.paddingRight} span={2}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, nextValues) =>
                prevValues.gekoppeldeGewaspercelen[index]?.fosfaatklasseBepalingMethode !==
                nextValues.gekoppeldeGewaspercelen[index]?.fosfaatklasseBepalingMethode
              }>
              {({ getFieldValue }) => {
                const fosfaattoestandCategorieen: PercelenModel['fosfaattoestandCategorieen'] = getFieldValue(['fosfaattoestandCategorieen']);
                const gewascodes: PercelenModel['gewascodes'] = getFieldValue(['gewascodes']);
                const gewas = gewascodes.find(code => code.gewascodeId === perceel.gewascodeId);
                const categoryFixerend = fosfaattoestandCategorieen?.find(f => f.fixerend);
                const isgras = gewas?.bcid === 3 || gewas?.bcid === 4;
                let lowPal = false;
                let lowPw = false;
                if (perceel.pal && categoryFixerend && categoryFixerend.maximalePalWaarde) lowPal = perceel.pal < categoryFixerend.maximalePalWaarde;
                if (perceel.pw && categoryFixerend && categoryFixerend.maximalePwWaarde) lowPw = perceel.pw < categoryFixerend.maximalePwWaarde;

                const hidden = perceel?.fosfaatklasseBepalingMethode === 1 && isgras && (lowPal || lowPw);
                return (
                  perceel?.fosfaatklasseBepalingMethode === 0 && (
                    <Form.Item name={[index, 'fixerend']} noStyle valuePropName="checked" hidden={hidden}>
                      <Switch disabled={isKlwReadOnly} onClick={(_, e) => e.stopPropagation()} className={styles.alignSuper} />
                    </Form.Item>
                  )
                );
              }}
            </Form.Item>
          </Col>
          <Col className={styles.paddingRight} span={2}>
            <Form.Item name={[index, 'doorrekenen']} noStyle valuePropName="checked" hidden={!perceel.magDoorgerekendWorden}>
              <Switch disabled={isKlwReadOnly} onClick={(_, e) => e.stopPropagation()} className={styles.alignSuper} />
            </Form.Item>
          </Col>
          <Col span={2}>
            {perceel?.fosfaatklasseBepalingMethodeKiesbaar ? (
              <Form.Item name={[index, 'fosfaatklasseBepalingMethode']}>
                <Select
                  onClick={e => e.stopPropagation()}
                  disabled={isKlwReadOnly}
                  className="text-right"
                  options={Object.keys(methodes)
                    .filter(value => value !== '2')
                    .map(value => ({ value: parseFloat(value), label: methodes[value], className: 'text-right' }))}
                />
              </Form.Item>
            ) : (
              <span style={{ paddingRight: 8 }}>{methodes[perceel?.fosfaatklasseBepalingMethode]}</span>
            )}
          </Col>
        </>
      ) : shownGroup === 'koolstof' && gebruikKoppeltoolKoolstofBodem ? (
        <>
          <Col className={styles.paddingRight} span={3}>
            {roundAndDisplayWithDecimals(2)(perceel.soc)}
          </Col>
          <Col className={styles.paddingRight} span={3}>
            {roundAndDisplayWithDecimals(2)(perceel.organischeStof)}
          </Col>
          <Col className={styles.paddingRight} span={3}>
            {roundAndDisplayWithDecimals(2)(perceel.lutum)}
          </Col>
          <Col className={styles.paddingRight} span={3}>
            {roundAndDisplayWithDecimals(2)(perceel.cnRatio)}
            <Form.Item name={[index, 'fixerend']} noStyle valuePropName="checked" hidden />
            <Form.Item name={[index, 'doorrekenen']} noStyle valuePropName="checked" hidden />
            <Form.Item name={[index, 'fosfaatklasseBepalingMethode']} noStyle hidden />
          </Col>
        </>
      ) : null}
    </Row>
  );
};
